<template>
  <v-navigation-drawer v-model="drawer" fixed app class="secondary" dark right>
    <v-list two-line>
      <v-list-tile to="/calls/list" ripple>
        <v-list-tile-action>
          <v-icon>build</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{
            $vuetify.t('$vuetify.app.calls')
          }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <!--
      <v-list-tile to="/inbox" ripple>
        <v-list-tile-action>
          <v-icon>message</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{
            $vuetify.t('$vuetify.app.inbox')
          }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      -->
      <v-list-tile to="/help" ripple>
        <v-list-tile-action>
          <v-icon>help</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{
            $vuetify.t('$vuetify.app.help')
          }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="reloadApp()" ripple>
        <v-list-tile-action>
          <v-icon>refresh</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{
            $vuetify.t('$vuetify.app.refresh')
          }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile to="/offline-requests" ripple>
        <v-list-tile-action>
          <v-icon style="width:30px">wifi_off</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Offline Requests</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="logoutClicked" ripple>
        <v-list-tile-action>
          <v-icon>lock</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{
            $vuetify.t('$vuetify.app.logout')
          }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-list v-if="user">
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title
            >Logged in as: {{ user.full_name }}</v-list-tile-title
          >
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Version: {{ version }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MainMenu',
  props: {
    drawerProp: Boolean
  },
  data() {
    return {}
  },
  computed: {
    drawer: {
      get: function() {
        return this.drawerProp
      },

      set: function() {
        return this.drawerProp
      }
    },
    ...mapGetters({
      getActiveCall: 'calls/getActiveCall',
      user: 'root/user',
      version: 'root/version'
    })
  },
  mounted() {},
  methods: {
    ...mapActions({
      logout: 'root/logout',
      setLoginLayout: 'root/setLoginLayout'
    }),

    logoutClicked() {
      this.logout({})
      this.$router.push('/login')
    },
    reloadApp() {
      window.location.reload()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
